import React from 'react';
import { useIntl } from 'react-intl';
import DataBox from '../../../Dashboard/DataBox';
import RedemptionGraphWidget from '../../Components/RedemptionGraphWidget';

const GraphsWidget = function GraphsWidget({
  userRedemptionData,
  branchRedemptionData,
}) {
  const intl = useIntl();
  return (
    <>
      {userRedemptionData && (
        <DataBox
          flex="0 1 50%"
          title={intl.messages.USERS_REDEMPTION}
          widget={
            <RedemptionGraphWidget
              redemptionData={userRedemptionData}
              enableScroll
              noData={
                userRedemptionData?.length === 0 ||
                userRedemptionData?.[0]?.totalPractices === 0
              }
            />
          }
        />
      )}
      {branchRedemptionData && (
        <DataBox
          flex="0 1 50%"
          title={intl.messages.BRANCHES_REDEMPTION}
          widget={
            <RedemptionGraphWidget
              redemptionData={branchRedemptionData}
              noData={
                branchRedemptionData?.length === 0 ||
                branchRedemptionData?.[0]?.totalPractices === 0
              }
            />
          }
        />
      )}
    </>
  );
};

export default GraphsWidget;
